"use client"
import Image from "next/image";
import { LibraryResource } from "@prisma/client";
import { AppWindow, File, Video, Lock } from "lucide-react";
import Link from "next/link";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/shadcn/dialog";

const Resource = ({data, user}: {data: LibraryResource, user: {id:string} | null}) => {

    const content = (
        <div className="p-2 space-y-2 w-40 text-left">
            <div className="my-6 bg-gray-200 border-2 rounded-lg overflow-hidden h-18 flex items-center justify-center relative">
                {data.thumbnail && <Image src={data.thumbnail} alt={data.title} width={200} height={200} />}
                {data.private && (
                    <div className="absolute top-1 right-1 bg-gray-500 p-1.5 rounded-full text-white shadow-sm">
                        <Lock className="size-3" />
                    </div>
                )}
            </div>
            {data.type === "multimedia" && <div className="flex items-center text-xs gap-1"><Video className="size-4" />Multimedia</div>}
            {data.type === "documento" && <div className="flex items-center text-xs gap-1"><File className="size-4" />Documento</div>}
            {data.type === "recurso-web" && <div className="flex items-center text-xs gap-1"><AppWindow className="size-4" />Recurso web</div>}
            <h3 className="font-semibold">{data.title}</h3>
            <p className="text-xs">{data.description}</p>
        </div>
    );

    if (data.private && !user) {
        return (
            <Dialog>
                <DialogTrigger asChild>
                    <button className="appearance-none bg-transparent border-none p-0 m-0 block h-full text-left">
                        {content}
                    </button>
                </DialogTrigger>
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle>Solo para miembros del MSU</DialogTitle>
                        <DialogDescription>
                            Este recurso es exclusivo para miembros del MSU. Ingresa con tu documento y contraseña para acceder a él.
                        </DialogDescription>
                    </DialogHeader>
                    <div className="flex justify-end mt-4">
                        <Link href={`/biblioteca/r/${data.id}`} target="_blank" className="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground shadow-sm hover:bg-primary/90 h-9 px-4 py-2">
                            Continuar
                        </Link>
                    </div>
                </DialogContent>
            </Dialog>
        );
    }

    return (
        <Link href={`/biblioteca/r/${data.id}`} target="_blank" className="block h-full">
            {content}
        </Link>
    );
};

export default Resource;
